import { render, staticRenderFns } from "./GeneralConfigurationPage.vue?vue&type=template&id=22b9af76&scoped=true&"
import script from "./GeneralConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./GeneralConfigurationPage.vue?vue&type=script&lang=js&"
import style0 from "./GeneralConfigurationPage.vue?vue&type=style&index=0&id=22b9af76&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9af76",
  null
  
)

export default component.exports